
export function formatDate(dateString) {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  // Format date and add ordinal suffix
  let formatted = date.toLocaleString('en-US', options);
  // Add ordinal suffix (e.g., "12th" instead of "12")
  const day = date.getDate();
  const suffix = getOrdinalSuffix(day);
  formatted = formatted.replace(new RegExp(`\\b${day}\\b`), `${day}${suffix}`);
  // Clean up comma spacing and ensure proper format
  return formatted.replace(/,([^,]*)$/,'$1');
}

// Helper function for ordinal suffixes
function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return 'th'; // 4th to 20th
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

export function formatCurrency(number, currencySymbol = '$', decimalPlaces = 2) {
  number = parseInt(number)
  if (isNaN(number)) return `${currencySymbol}0${decimalPlaces > 0 ? '.00' : ''}`;
  let formattedNumber = number.toFixed(decimalPlaces).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  // Remove trailing .00 if present and decimalPlaces > 0
  if (decimalPlaces > 0 && formattedNumber.endsWith('.00')) {
    formattedNumber = formattedNumber.slice(0, -3);
  }
  if (decimalPlaces === 0) {
    formattedNumber = formattedNumber.split('.')[0];
  }
  if (number < 0) {
    return `-${currencySymbol}${formattedNumber.replace('-', '')}`;
  }
  return `${currencySymbol}${formattedNumber}`;
}
